import alert from '@/plugins/alert'
import { Lead } from '@/plugins/api'

export default {
  namespaced: true,
  state: {
    leads: {},
    count: 0
  },
  actions: {
    async fetchLeads({ commit }, options) {
      commit(
        'setLeads',
        await Lead.fetch({
          ...options,
          _sort: 'date:DESC',
          _limit: -1
        })
      )
    },
    async countLeads({ commit }, options) {
      commit('setCount', await Lead.count(options))
    },
    async fetchLead({ commit }, leadId) {
      commit('setLead', await Lead.fetchOne(leadId))
    },
    // api is create or update. If record exist then create.
    async createLead({ commit }, { data, options }) {
      commit('setLead', await Lead.create(data, options))
      alert.success('Cập nhật thành công!')
    },
    async removeLead({ commit }, id) {
      await Lead.remove(id)
      commit('removeLead', id)
      alert.success('Xóa thành công!')
    },
    setLead({ commit, state }, lead) {
      commit('setLead', lead)
    },
    async removeLeads({ dispatch }, items) {
      for (let item of items) {
        await dispatch('removeLead', item.id)
      }
    },
    async updateLead({ commit, state }, { id, ...lead }) {
      try {
        const result = await Lead.update(id, lead)
        commit('setLead', lead)
        return result
      } catch (e) {
        alert.error(e)
      }
    },
    async updateLeads({ dispatch }, items) {
      await Promise.all(
        items.map(item => dispatch('createLead', { data: item }))
      )
    }
  },
  mutations: {
    setLeads(state, leads) {
      state.leads = [...leads].reduce(
        (accumulator, currentValue) => ({
          ...accumulator,
          [currentValue.id]: currentValue
        }),
        {}
      )
    },
    setLead(state, lead) {
      state.leads = {
        ...state.leads,
        [lead.id]: lead
      }
    },
    removeLead(state, leadId) {
      delete state.leads[leadId]
      state.leads = { ...state.leads }
    },
    setCount(state, count) {
      state.count = count
    }
  },
  getters: {
    leads: state => {
      return Object.values(state.leads || {})
    },
    lead: state => id => {
      return state.leads[id]
    },
    count: state => {
      return state.count
    }
  }
}
